import React from 'react';
import ItemGrid from '../common/ItemGrid';
import ItemCard from '../common/ItemCard';
import ItemListView from '../common/ItemListView';
import { courseService } from '../../services/api';
import { useUser } from '../../context/UserContext';
import './CourseGrid.css';

const CoursesGrid = () => {
  const { user } = useUser();
  const isManager = user?.role_name === 'manager' || user?.role_name === 'Manager' || user?.role_id === 7;
  const fetchCourses = async (page, limit, searchTerm, sortOrder, authorId, userId, audienceType) => {
    return await courseService.getCourses(page, limit, searchTerm, sortOrder, authorId, userId, audienceType);
  };

  return (
    <ItemGrid
      title="All Courses"
      description=""
      itemType="course"
      fetchItems={fetchCourses}
      ItemCardComponent={(props) => <ItemCard {...props} itemType="course" />}
      ItemListComponent={(props) => <ItemListView {...props} itemType="course" />}
      createPermission="create_course"
      createPath="/course/form"
      authorFilterEnabled={!isManager}
      onClearFilters={() => window.dispatchEvent(new CustomEvent('resetItemGrid'))}
    />
  );
};

export default CoursesGrid;